// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"718bdd6e","126":"def803dc","171":"ba383de2","378":"59bfab8d","453":"87ebbf2f"}[chunkId] + ".chunk.js";
};